import React, {useEffect, useState} from "react";
import {useProductListContext} from "../../ProductListProvider/ProductListProvider";
import {ProductListOrder, ProductListOrderBy} from "@connox/typescript-library";
import {useTranslation} from "react-i18next";
import Select, {SelectOptionType} from "../../../lib/form/Select/Select";
import nlOptionsFormStyles from "../../../newsletter/NewsLetterOptionsForm.module.scss";
import appToggleStyles from "../AppToggleContainer/AppToggleContainer.module.scss";
import selectStyles from "../ProductFilterSelect/ProductFilterSelect.module.scss";
import styles from "./ProductSortInput.module.scss";
import {useMediaQuery} from "react-responsive";
import RadioButton from "../../../lib/form/RadioButton/RadioButton";
import {getShopId} from "../../../lib/getShopId";

export type SortOption = SelectOptionType & {
  orderBy: ProductListOrderBy;
  order: ProductListOrder;
};

const ProductSortInput: React.FC = () => {
  const {state, dispatch} = useProductListContext();
  const {t} = useTranslation();
  const isMobile = useMediaQuery({query: "(max-width: 480px)"});

  const sortOptions: SortOption[] = [
    {
      value: 1,
      text: t("Beliebtheit"),
      orderBy: "rank",
      order: "asc",
    },
    {
      value: 2,
      text: t("Höchster Preis"),
      orderBy: "price",
      order: "desc",
    },
    {
      value: 3,
      text: t("Niedrigster Preis"),
      orderBy: "price",
      order: "asc",
    },
    {
      value: 4,
      text: t("Neueste"),
      orderBy: "newest",
      order: "desc",
    }
  ];

  // Show only in DE. Also refer to the initializing `useMemo()` in `ProductListProvider.tsx`
  if (getShopId() === 100001) {
    sortOptions.push({
      value: 5,
      text: t("Relevanz"),
      orderBy: "innofind",
      order: "asc",
    });
  }

  const [selectedOptionValueNumber, setSelectedOptionValueNumber] = useState<number>(
    Number(sortOptions.find((so) => so.orderBy === state.orderBy && so.order === state.order)?.value) ?? 1,
  );

  useEffect(() => {
    const item = sortOptions.find((option) => {
      return option.orderBy === state.orderBy && option.order === state.order;
    });
    setSelectedOptionValueNumber(item ? (item.value as number) : 1);
  }, [state.order, state.orderBy]);

  const onChange = (value: string | number) => {
    const item = sortOptions.find((option) => option.value === Number(value));
    setSelectedOptionValueNumber(item ? (item.value as number) : 1);
    dispatch({
      type: "SET_SORT",
      payload: {orderBy: item?.orderBy ?? undefined, order: item?.order ?? undefined, doUrlParamUpdate: true},
    });
  };

  return (
    <>
      {!isMobile && (
        <div className={appToggleStyles.item}>
          <Select
            value={selectedOptionValueNumber}
            styles={{
              wrapper: [nlOptionsFormStyles.select, appToggleStyles.formElementContainer].join(" "),
              optionsWrapper: selectStyles.optionsContainer,
              option: selectStyles.optionSort,
              closeArrow: appToggleStyles.customArrow,
              openArrow: appToggleStyles.isOpen,
              selected: selectStyles.selected,
            }}
            onChange={onChange}
            options={sortOptions}
            title={t("Sortieren: ")}
          />
        </div>
      )}
      {isMobile && (
        <div>
          {sortOptions.map((option) => {
            return (
              <div key={option.value} className={styles.radioWrapper}>
                <RadioButton
                  value={option.value}
                  checked={selectedOptionValueNumber === option.value}
                  name={"sort"}
                  color={"#1ba1e2"}
                  onChange={(evt) => {
                    onChange(evt.target.value);
                  }}
                >
                  {option.text}
                </RadioButton>
              </div>
            );
          })}
        </div>
      )}
    </>
  );
};

export default ProductSortInput;
